<section class="modal-container">
  <header>
    <h2>
      {{ 'aria-labels.document' | translate }}
      {{ 'aria-labels.setting' | translate }}
    </h2>
    <button (click)="cancel()" aria-label="Close">
      <img src="../../../../../../assets/report_v2/close_big.svg" alt="close" />
    </button> 
  </header>
  <section class="document_settings">
    <h3>{{ 'individual.upload.translate_document' | translate }}</h3>
    <!-- <p>Translation</p> -->
    <!-- <app-translate></app-translate> -->
  </section>
  <section class="document_settings">
    <!-- <p>{{ 'individual.upload.translate_document' | translate }}:</p> -->
    <div class="text_collection">
      <div class="text_collection_header">
        <!-- <p>Interface language:</p> -->
         <label for="languageSelect" class="interface-languages">{{'reports_io.interface_language' | translate }}</label>
        <p class="interface-languages" id="langTip">{{'reports_io.translate_interface' | translate }}</p>
      </div>
      <div class="text_collection_body">
        <app-translate></app-translate>
      </div>
    </div>
  </section>
  <div class="share-report-line">
  </div>

  <!-- Reset Originality Report Section -->
  <section class="document_settings reset-originality-section" *ngIf="canPerformActions() && !isNotStudentPrecheck">
    <div class="text_collection">
      <div class="text_collection_header">
        <h3 class="reset-section-title">{{ 'report_settings.reset_section_title' | translate }}</h3>
        <p class="interface-languages">{{ 'report_settings.reset_section_description' | translate }}</p>
      </div>
      <div class="text_collection_body reset-report-actions">
        <button type="button" class="button-primary reset-report-btn" (click)="openResetConfirmationModal()">{{ 'report_settings.reset_report_button' | translate }}</button>
      </div>
    </div>
  </section>

    <div class="share-report-line">
    </div>
  <header>
    <h2 class="fw-bold"
      *ngIf="isPrivacyDataLoaded && !isOnIA && (!isSharedSession || currentShareDetails?.share?.accessPermission !== 'view') && !isPrecheckShared">
      {{ 'app.privacy_settings' | translate }}</h2>
  </header>

  <section class="modal-body"
    *ngIf="isPrivacyDataLoaded && !isOnIA && (!isSharedSession || currentShareDetails?.share?.accessPermission !== 'view') && !isPrecheckShared">
    <!-- CASE 1: When the the  professor  opens the  student report -->
    <ng-container *ngIf="submissionUserId != this.loggedInUser?.id">
      <section class="modal-action" *ngIf="!(isDocumentInArchive == undefined)" [style.background-color]="!isDocumentInArchive && data.submission.archive ? getCorrectedText().backgroundColor : ''">
        <label for="delete_doc_from_arch" [ngClass]="{ disabled: isDocumentInArchive == false }" class="privacy_title">
          <!-- {{ 'report.give_student_permission_to_delete_document' | translate }} -->
          <div class="d-flex-settings">
            <div>
              <img src="../../../../../../assets/images/warning-circled-filled.svg" alt="Warning icon" />
            </div>
            <div>
              {{ 'report_settings.allow_students_to_delete_document_from_archive' | translate }}
            </div>
          </div>
            <p class="permissions_paragraph" >
            <ng-container *ngIf="isDocumentInArchive === false; else originalText"><div>
              {{ getCorrectedText().text }}
            </div></ng-container>
            <ng-template #originalText>
              {{ 'report_settings.allow_students_to_delete_document_from_archive_description' | translate }}
            </ng-template>
          </p>
        </label>
        <label class="switch">
          <input type="checkbox" name="delete_doc_from_arch" id="delete_doc_from_arch" aria-labelledby="delete_doc_from_arch_label"
            [disabled]="isDocumentInArchive == false" [(ngModel)]="permissions.deleteInArchive" />
          <span class="slider round"></span>
        </label>

      </section>
      <section class="modal-action">
        <label for="delete_doc_from_repo" class="privacy_title">
          <div class="d-flex-settings">
            <div>
              <img src="../../../../../../assets/images/warning-circled-filled.svg" alt="Warning icon" />
            </div>
            <div class="subtitle_title">
              {{ 'report_settings.allow_students_to_delete_document_from_repository' | translate }}
            </div>
          </div>
          <p class="permissions_paragraph">{{ 'report_settings.allow_students_to_delete_document_from_repository_description' | translate }}</p>
        </label>
        <!-- <input type="checkbox" name="delete_doc_from_repo" id="delete_doc_from_repo"
          [(ngModel)]="permissions.deleteEverything" (change)="deleteEverything()" /> -->

        <label class="switch">
          <input type="checkbox" name="delete_doc_from_repo" id="delete_doc_from_repo" aria-labelledby="delete_doc_from_repo_label"
            [(ngModel)]="permissions.deleteEverything" (change)="deleteEverything()" />
          <span class="slider round"></span>
        </label>


      </section>



      <section class="modal-action">
        <label for="delete_doc_from_repo" class="privacy_title">
          <!-- {{ 'report.give_student_permission_to_delete_everything' | translate }} -->
          <div class="d-flex-settings">
            <div>
              <img src="../../../../../../assets/images/trash.svg" alt="Delete icon" />
            </div>
            <div class="subtitle_title">
              {{ 'report_settings.delete_document' | translate }}
            </div>
          </div>
          <p class="permissions_paragraph">{{ 'report_settings.delete_document_description' | translate }}</p>
          <!-- <button [matTooltip]="'new_entries.give_student_permission_to_delete_document_repo_info' | translate"
            matTooltipPosition="above" matTooltipClass="new_report_tooltip">
            <img src="../../../../../../assets/report_v2/info.svg" alt="" />
          </button> -->
        </label>
        <!-- <input type="checkbox" name="delete_doc_from_repo" id="delete_doc_from_repo"
          [(ngModel)]="permissions.deleteEverything" (change)="deleteEverything()" /> -->

        <!-- <label class="switch">
          <input type="checkbox"
                name="delete_doc_from_repo"
                id="delete_doc_from_repo"
                [(ngModel)]="permissions.deleteEverything"
                (change)="deleteEverything()" />
          <span class="slider round"></span>
        </label> -->
        <button class="button-primary red text-button delete-text-button" (click)="deleteSettingsDocument()">{{'report_settings.delete_button' | translate}}</button>
      </section>


    </ng-container>

<!-- CASE 2: When the  professor opens its  own  report or CASE 3: When the  student  opens  its  own report -->
    <div class="modal-action" [ngClass]="deleteDocumentInArchive ? 'deleted-document' : ''"
      *ngIf="((data.submission.archive === true && submissionUserId == this.loggedInUser?.id && data.submission.archive && this.loggedInUser.roleId === 10) || (submissionUserId == this.loggedInUser?.id && data.submission.archive && this.loggedInUser.roleId === 9 && this.permissions.deleteInArchive)); else noPermission">
      <span [attr.aria-label]="'aria-labels.delete_document' | translate" class="privacy_title">
        <!-- {{ 'report.delete_document_from_archive' | translate }} -->

        <div class="d-flex-settings">
          <div>
            <img src="../../../../../../assets/images/warning-circled-filled.svg" alt="Warning icon" />
          </div>
          <div>
            {{'report_settings.delete_from_archives' | translate}}
          </div>
        </div>
        <p class="permissions_paragraph">
          {{ deleteDocumentInArchive 
              ? ('report_settings.document_has_been_deleted' | translate) 
              : ('report_settings.deletes_from_archive' | translate) 
          }}
        </p>
      </span>
      <button [ngClass]="deleteDocumentInArchive ? 'button-primary gray delete-text-button' : 'button-primary red delete-text-button'" [disabled]="deleteDocumentInArchive" (click)="deleteDocument(1)" tabindex="0">{{ 'app.delete' | translate }}</button>
    </div>

   
    <ng-container
    *ngIf="loggedInUser.roleId === 9 && submissionUserId == loggedInUser?.id && !(data.submission.archive && permissions.deleteInArchive) && !permissions.deleteEverything">
      <section class="modal-action">
        <label for="delete_doc_from_arch" class="privacy_title">
          <div class="d-flex-settings">
            <div>
              <img src="../../../../../../assets/images/warning-circled-filled.svg" alt="Warning icon" />
            </div>
            <div>
              {{'report_settings.deletion_disabled' | translate}}
            </div>
          </div>
          <p class="permissions_paragraph">{{'report_settings.deletion_disabled_not_available' | translate}}</p>
        </label>
      </section>
     <div class="btn-close-style">
         <button class="secondary-button cancel-btn" (click)="cancel()">
            {{'report_settings.cancel' | translate}}
        </button>
     </div>
    </ng-container>

    <!-- <div *ngIf="permissions?.deleteSources">
        <span tabindex="0" [attr.aria-label]="'aria-labels.delete_similarity_sources' | translate">{{ 'report.delete_similarity_sources' | translate }}</span>
        <button class="deleteBtn"  (click)="deleteDocument(0)" tabindex="0">{{ 'app.delete' | translate }}</button>
      </div> -->

      <!-- <ng-container *ngIf="!(!isDocumentInArchive && !permissions.deleteEverything && (loggedInUser.roleId === 9) && !deleteDocumentInArchive)">
        <div class="btn-close-style">
          <button class="secondary-button cancel-btn" (click)="cancel()">Cancel</button>
        </div>
      </ng-container> -->

      <section class="modal-action" *ngIf="(!isDocumentInArchive || deleteDocumentInArchive) && data.submission.archive === false && this.data.isNotStudentPrecheck && !isDocumentInArchive && permissions.deleteEverything && (loggedInUser.roleId === 9)">
        <label for="delete_doc_from_arch" [ngClass]="{ disabled: isDocumentInArchive == false }" class="privacy_title">
          <div class="d-flex-settings">
            <div>
              <img src="../../../../../../assets/images/warning-circled-filled.svg" alt="Warning icon" />
            </div>
            <div>
              {{'report_settings.delete_from_archives' | translate}}
            </div>
          </div>
          <p class="permissions_paragraph">{{'report_settings.document_not_archived' | translate}}</p>
        </label>
        <button class="button-primary gray delete-text-button" disabled tabindex="0">{{ 'app.delete' | translate }}</button>
      </section>

    <div class="modal-action" [ngClass]="deleteDocumentInRepository ? 'deleted-document' : ''"
      *ngIf="submissionUserId == this.loggedInUser?.id && (this.loggedInUser?.roleId !== 9 || this.permissions.deleteEverything)">
      <span class="privacy_title" [attr.aria-label]="'aria-labels.delete_everything' | translate">
        <!-- {{ 'delete.delete_everything' | translate }} -->
        <div class="d-flex-settings">
          <div>
            <img src="../../../../../../assets/images/warning-circled-filled.svg" alt="Warning icon" />
          </div>
          <h3>
            {{'report_settings.delete_from_repository' | translate}}
          </h3>
        </div>
        <p class="permissions_paragraph">{{'report_settings.document_delete_from_platform' | translate}}</p>
      </span>
      <button [ngClass]="deleteDocumentInRepository ? 'button-primary gray delete-text-button' : 'button-primary red delete-text-button'" [disabled]="deleteDocumentInRepository" (click)="deleteDocument(2)" tabindex="0">{{ 'app.delete' | translate }}</button>
    </div>
  </section>


  <button *ngIf="((this.data.isNotStudentPrecheck && submissionUserId == this.loggedInUser?.id && (this.loggedInUser?.roleId !== 9 || this.permissions.deleteEverything)) || 
  (this.loggedInUser?.roleId === 9 && !isDocumentInArchive) && (this.isNotStudentPrecheck && this.loggedInUser?.roleId === 9)) && 
  !(isDocumentInArchive && (loggedInUser.roleId === 9 && !this.permissions.deleteInArchive && !this.permissions.deleteEverything && data.submission.archive))" class="secondary-button mt-20" (click)="cancel()">Close</button>
 
 
 <!-- <button *ngIf="(this.data.isNotStudentPrecheck && submissionUserId == this.loggedInUser?.id && (this.loggedInUser?.roleId !== 9 || this.permissions.deleteEverything)) || 
  (this.loggedInUser?.roleId === 9 && !isDocumentInArchive) || !(this.isNotStudentPrecheck && this.loggedInUser.roleId === 9)" class="secondary-button mt-20" (click)="cancel()">Close</button> -->
  

  <!-- <button class="cancel-btn" (click)="cancel()">
      Close
    </button> -->

  <!-- Share Report Section -->
  <section class="share-report-section" *ngIf="canPerformActions() && !isNotStudentPrecheck">
    <header>
      <h2>{{'report_settings.share_report' | translate}}</h2>
    </header>

    <!-- Share Method Selection -->
    <div class="share-method-group">
      <div class="radio-options" role="radiogroup" [attr.aria-label]="'report_settings.share_report' | translate">
        <div class="radio-option">
          <input type="radio" id="share-email" value="email" [checked]="shareMethod === 'email'"
            [attr.aria-checked]="shareMethod === 'email'"
            (change)="setShareMethod('email')" (keydown)="onShareMethodKeydown($event, 'email')" />
          <label for="share-email">{{'report_settings.share_report_email' | translate}}</label>
        </div>

        <div class="radio-option">
          <input type="radio" id="share-link" value="link" [checked]="shareMethod === 'link'"
            [attr.aria-checked]="shareMethod === 'link'"
            (change)="setShareMethod('link')" (keydown)="onShareMethodKeydown($event, 'link')" />
          <label for="share-link">{{'report_settings.share_report_link' | translate}}</label>
        </div>
      </div>

      <button class="cancel-selection" *ngIf="shareMethod !== null" (click)="clearShareMethod()">
        {{'report_settings.cancel' | translate}}
      </button>
    </div>

    <!-- Email Sharing Options - Only show when email is selected -->
    <div class="share-options" *ngIf="shareMethod === 'email'">
      <!-- Precheck Disclaimer for Email Sharing -->
      <!-- <div class="precheck-disclaimer" *ngIf="isStudentsDocument">
        <img src="../../../../../../assets/report_v2/info.svg" alt="Info" class="disclaimer-icon" />
        <ng-container *ngIf="isStudentsDocument">
          <div class="disclaimer-content">
            <strong>Note:</strong> Recipients will have view-only access as this is a student submission. Edit permissions are not available for student reports.
          </div>
        </ng-container>
      </div> -->
      <div class="email-access-row">
        <div class="email-input-wrapper">
          <label for="recipient-email">{{'report_settings.email_address' | translate}}</label>
          <input type="email" id="recipient-email" [(ngModel)]="recipientEmail" (ngModelChange)="onEmailChange()"
            placeholder="{{ 'share_report.email_address' | translate }}" [disabled]="isLoadingShare" />
        </div>

        <div class="access-type-wrapper">
          <label for="access-type">{{'report_settings.set_access' | translate}}</label>
          <select id="access-type" [(ngModel)]="accessType" (change)="setAccessType(accessType)"
            [disabled]="isLoadingShare || !isAccessTypeEnabled">
            <option value="one_time">{{'report_settings.one_time_view' | translate}}</option>
            <option value="unlimited">{{'report_settings.unlimited_access' | translate}}</option>
            <option value="time_based">{{'report_settings.time_based_access' | translate}}</option>
          </select>
        </div>

        <div class="access-mode-wrapper">
          <label for="access-permission">{{'report_settings.set_mode' | translate}}</label>
          <select id="access-permission" [(ngModel)]="accessPermission" (change)="onAccessPermissionChange()"
            [disabled]="isLoadingShare || !isAccessTypeEnabled">
            <option value="view">{{'report_settings.view' | translate}}</option>
            <option value="edit">{{'report_settings.edit' | translate}}</option>
          </select>
        </div>

        <button class="invite-btn" (click)="sendEmailInvitation()" [disabled]="!isInviteButtonEnabled">
          <span *ngIf="!isLoadingShare">{{'report_settings.invite' | translate}}</span>
          <span *ngIf="isLoadingShare">{{'report_settings.sending' | translate}}</span>
        </button>
      </div>

      <!-- Optional message for email sharing -->
      <div class="share-message-wrapper" *ngIf="shareMethod === 'email'">
        <label for="share-message">{{'report_settings.message_optional' | translate}}</label>
        <textarea id="share-message" [(ngModel)]="shareMessage"
          placeholder="{{ 'share_report.personal_message' | translate }}" [disabled]="isLoadingShare" rows="3"></textarea>
      </div>

      <!-- Time-based duration picker for email -->
      <div class="time-based-options" *ngIf="shouldShowTimeOptions">
        <div class="inline-time-section">
          <div class="current-time-wrapper">
            <label>{{'report_settings.current_time' | translate}}</label>
            <input type="text" [value]="currentTime" disabled class="current-time-input" />
          </div>

          <div class="end-date-wrapper">
            <label for="end-date">{{'report_settings.access_expires' | translate}}</label>
            <input type="datetime-local" id="end-date" [(ngModel)]="timeBasedEndDate" (change)="onEndDateChange()"
              [disabled]="isLoadingShare" />
          </div>

          <div class="duration-preview-wrapper" *ngIf="durationPreview">
            <label>{{'report_settings.duration' | translate}}</label>
            <div class="duration-display" [ngClass]="{'invalid-duration': durationPreview.includes('Invalid')}">
              {{ durationPreview }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Link Sharing Options - Only show when link is selected -->
    <div class="share-options" *ngIf="shareMethod === 'link'">
      <!-- Precheck Disclaimer for Link Sharing -->
      <!-- <div class="precheck-disclaimer" *ngIf="isStudentsDocument">
        <img src="../../../../../../assets/report_v2/info.svg" alt="Info" class="disclaimer-icon" />
        <ng-container *ngIf="isStudentsDocument">
          <div class="disclaimer-content">
            <strong>Note:</strong> Recipients will have view-only access as this is a student submission. Edit permissions are not available for student reports.
          </div>
        </ng-container>
      </div> -->
      <div class="link-access-row">
        <div class="access-type-wrapper">
          <label for="link-access-type">{{'report_settings.set_access' | translate}}</label>
          <select id="link-access-type" [(ngModel)]="accessType" (change)="setAccessType(accessType)"
            [disabled]="isLoadingShare">
            <option value="one_time">{{'report_settings.one_time_view' | translate}}</option>
            <option value="unlimited">{{'report_settings.unlimited_access' | translate}}</option>
            <option value="time_based">{{'report_settings.time_based_access' | translate}}</option>
          </select>
        </div>

        <div class="access-mode-wrapper">
          <label for="link-access-permission">{{'report_settings.set_mode' | translate}}</label>
          <select id="link-access-permission" [(ngModel)]="accessPermission" (change)="onAccessPermissionChange()"
            [disabled]="isLoadingShare">
            <option value="view">{{'report_settings.view' | translate}}</option>
            <option value="edit">{{'report_settings.edit' | translate}}</option>
          </select>
        </div>

        <button class="copy-link-btn" (click)="generateShareLink()" [disabled]="!isCopyLinkButtonEnabled">
          <!-- <img src="../../../../../../assets/report_v2/copy.svg" alt="copy" /> -->
          <span *ngIf="!isLoadingShare">{{'report_settings.generate_link' | translate}}</span>
          <span *ngIf="isLoadingShare">{{'report_settings.generating' | translate}}</span>
        </button>
      </div>

      <!-- Generated Link Display -->
      <div class="generated-link-section" *ngIf="generatedShareLink">
        <div class="generated-link-container">
          <label>{{'stylometrics_component_ai.report_link' | translate}}</label>
          <div class="link-display-row">
            <input type="text" [value]="generatedShareLink" readonly class="generated-link-input" />
            <button class="copy-link-action-btn" (click)="copyLinkToClipboard()"
              [title]="linkCopyMessage || 'Copy link to clipboard'">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6C4 4.89543 4.89543 4 6 4H8"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <rect x="8" y="2" width="8" height="4" rx="1" ry="1" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <span>{{ linkCopyMessage || 'Copy' }}</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Time-based duration picker for link -->
      <div class="time-based-options" *ngIf="accessType === 'time_based'">
        <div class="inline-time-section">
          <div class="current-time-wrapper">
            <label>{{'report_settings.current_time' | translate}}</label>
            <input type="text" [value]="currentTime" disabled class="current-time-input" />
          </div>

          <div class="end-date-wrapper">
            <label for="link-end-date">{{'report_settings.access_expires' | translate}}</label>
            <input type="datetime-local" id="link-end-date" [(ngModel)]="timeBasedEndDate" (change)="onEndDateChange()"
              [disabled]="isLoadingShare" />
          </div>

          <div class="duration-preview-wrapper" *ngIf="durationPreview">
            <label>{{'report_settings.duration' | translate}}</label>
            <div class="duration-display" [ngClass]="{'invalid-duration': durationPreview.includes('Invalid')}">
              {{ durationPreview }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Who has access section -->
    <div class="access-list-section">
      <h3 id="access-management-heading">{{'report_settings.access_management' | translate}}</h3>

      <table class="access-table" aria-labelledby="access-management-heading" *ngIf="shareAccesses.length > 0">
        <thead>
          <tr class="access-table-header">
            <th scope="col" class="email-col">{{'report_settings.email' | translate}}</th>
            <th scope="col" class="access-type-col">{{'report_settings.access_type' | translate}}</th>
            <th scope="col" class="mode-col">{{'report_settings.mode' | translate}}</th>
            <th scope="col" class="status-col">{{'report_settings.status' | translate}}</th>
            <th scope="col" class="action-col">{{'report_settings.action' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let share of shareAccesses">
            <tr class="access-row">
              <td class="email-col">
                <button type="button" class="email-with-icon"
                  (click)="toggleRowExpansion(share.id)"
                  [attr.aria-expanded]="isRowExpanded(share.id)">
                  <span class="email-text">{{ share.email }}</span>
                  <span class="expand-icon" [ngClass]="{'expanded': isRowExpanded(share.id)}">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                      <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </span>
                </button>
              </td>
              <td class="access-type-col">
                <select class="access-type-select" [value]="share.accessType" [disabled]="true"
                  (click)="$event.stopPropagation()">
                  <option value="one_time">{{'report_settings.one_time_view' | translate}}</option>
                  <option value="unlimited">{{'report_settings.unlimited_access' | translate}}</option>
                  <option value="time_based">{{'report_settings.time_based_access' | translate}}</option>
                </select>
              </td>
              <td class="mode-col">
                <span class="mode-text"
                  [ngClass]="{'mode-edit': share.accessPermission === 'edit', 'mode-view': share.accessPermission === 'view'}">
                  {{ share.accessPermission === 'edit' ? ('report_settings.edit' | translate) : (share.accessPermission === 'view' ? ('report_settings.view' | translate) : share.accessPermission) }}
                </span>
              </td>
              <td class="status-col">
                <span class="status-text" [ngClass]="getStatusClass(share)">
                  {{ getStatusDisplay(share.status) }}
                </span>
              </td>
              <td class="action-col">
                <button class="remove-link" (click)="removeShareAccess(share.id); $event.stopPropagation()"
                  [disabled]="isLoadingShare || share.isRevoked">
                  {{'report_settings.remove' | translate }}
                </button>
              </td>
            </tr>
            <tr class="expanded-details-row" *ngIf="isRowExpanded(share.id)">
              <td colspan="5" class="expanded-details">
                <div class="details-content">
                  <div class="detail-row">
                    <span class="label">{{'report_settings.share_type' | translate}}</span>
                    <span class="value">{{ getShareTypeDisplayText(share.shareType) }}</span>
                  </div>
                  <div class="detail-row">
                    <span class="label">{{'report_settings.created' | translate}}</span>
                    <span class="value">{{ formatDate(share.shareCreatedAt) }}</span>
                  </div>
                  <div class="detail-row">
                    <span class="label">{{'report_settings.expires' | translate}}</span>
                    <span class="value" [ngClass]="{'expired': share.isExpired}">{{ formatDate(share.expiresAt) }}</span>
                  </div>
                  <div class="detail-row">
                    <span class="label">{{'report_settings.access_count' | translate}}</span>
                    <span class="value">{{ share.accessCount }}</span>
                  </div>
                  <div class="detail-row">
                    <span class="label">{{'report_settings.first_access' | translate}}</span>
                    <span class="value">{{ formatDate(share.firstAccessedAt) }}</span>
                  </div>
                  <div class="detail-row">
                    <span class="label">{{'report_settings.last_access' | translate}}</span>
                    <span class="value">{{ formatDate(share.lastAccessedAt) }}</span>
                  </div>
                  <div class="detail-row" *ngIf="share.shareType === 'email_share'">
                    <span class="label">{{'report_settings.email_sent' | translate}}</span>
                    <span class="value">{{ formatDate(share.emailSentAt) }}</span>
                  </div>
                  <div class="detail-row" *ngIf="share.shareType === 'email_share'">
                    <span class="label">{{'report_settings.email_delivered' | translate}}</span>
                    <span class="value" [ngClass]="{'success': share.emailDelivered, 'error': !share.emailDelivered}">
                      {{ share.emailDelivered ? 'Yes' : 'No' }}
                    </span>
                  </div>
                  <div class="detail-row">
                    <span class="label">{{'report_settings.share_id' | translate}}</span>
                    <span class="value id-value">{{ share.id }}</span>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>

      <div class="no-access-message access-table-empty" *ngIf="shareAccesses.length === 0">
        <span>{{'report_settings.no_access' | translate}}</span>
      </div>
    </div>
  </section>
  <!-- <section class="modal-btns" *ngIf="!this.data.isNotStudentPrecheck">
    <button class="submit-btn" (click)="submit()">
      {{ 'general.submit' | translate }} 
    </button>
    <button class="cancel-btn" (click)="cancel()">
      {{ 'general.cancel' | translate }}
    </button>
  </section> -->

  <!-- Recipient View - Show received shares -->
  <section class="shared-report-section" *ngIf="userRole === 'recipient'">
    <header>
      <h2>{{'report_settings.shared_doc_details' | translate}}</h2>
    </header>

    <div *ngIf="!currentShareDetails" class="no-access-message">
      <div class="empty-state">
        <span>{{'report_settings.loading_share_details' | translate}}</span>
      </div>
    </div>

    <div *ngIf="currentShareDetails">
      <!-- Your Access Card -->
      <div class="your-access-section">
        <h3>{{'report_settings.your_access' | translate}}</h3>
        <div class="access-card">
          <div class="access-card-header">
            <span class="document-title">{{ currentShareDetails.share.submission.title }}</span>
            <span class="status-badge" [ngClass]="'status-' + currentShareDetails.share.status">
              {{ getStatusDisplay(currentShareDetails.share.status) }}
            </span>
          </div>
          <div class="access-card-body">
            <div class="detail-item">
              <span class="label">{{'report_settings.shared_by' | translate}}</span>
              <span class="value">{{ currentShareDetails.share.sharedBy.name }} ({{
                currentShareDetails.share.sharedBy.email
                }})</span>
            </div>
            <div class="detail-item">
              <span class="label">{{'report_settings.access_type_doc' | translate}}</span>
              <span class="value">
                {{ getAccessTypeDisplay(currentShareDetails.share.accessType) }}
              </span>
            </div>
            <div class="detail-item">
              <span class="label">{{'report_settings.access_mode_doc' | translate}}</span>
              <span class="value">
                <span class="mode-text" [ngClass]="
                    'mode-' + currentShareDetails.share.accessPermission
                  ">
                  {{ currentShareDetails.share.accessPermission }} access
                </span>
              </span>
            </div>
            <div class="detail-item">
              <span class="label">{{'report_settings.shared_on' | translate}}</span>
              <span class="value">{{
                formatDate(currentShareDetails.share.shareCreatedAt)
                }}</span>
            </div>
            <div class="detail-item" *ngIf="
                currentShareDetails.share.accessType === 'time_based' &&
                currentShareDetails.share.expiresAt
              ">
              <span class="label">{{'report_settings.expires_on' | translate}}</span>
              <span class="value" [ngClass]="{
                  expired: currentShareDetails.share.status === 'expired'
                }">{{ formatDate(currentShareDetails.share.expiresAt) }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Others With Access Table -->
      <!-- <div class="others-with-access-section" *ngIf="
          currentShareDetails.othersWithAccess &&
          currentShareDetails.othersWithAccess.total > 0
        ">
        <div class="others-header-with-toggle">
          <h3>
            Who Else Has Access ({{
            currentShareDetails.othersWithAccess.total
            }})
          </h3>
          <button class="toggle-button" (click)="toggleOthersTable()"
                  [attr.aria-expanded]="isOthersTableExpanded"
                  aria-label="Toggle others with access table">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                 [ngClass]="{'expanded': isOthersTableExpanded}">
              <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>
        <div class="others-table" *ngIf="isOthersTableExpanded">
          <div class="others-table-header">
            <span>Recipient</span>
            <span>Access Type</span>
            <span>Access Mode</span>
            <span>Shared On</span>
          </div>
          <div class="others-table-body">
            <div class="others-row" *ngFor="let other of othersWithAccess">
              <div>
                <span class="recipient-info">
                  {{ other.recipientInfo }}
                  <span class="share-type-badge" [ngClass]="'badge-' + other.shareType">
                    {{ getShareTypeDisplayText(other.shareType) }}
                  </span>
                </span>
              </div>

              <div>
                <span class="access-info">
                  {{ getAccessTypeDisplay(other.accessType) }}
                </span>
              </div>

              <div>
                <span class="access-info">
                  <span class="mode-text" [ngClass]="'mode-' + other.accessPermission">
                    {{ other.accessPermission }}
                  </span>
                </span>
              </div>

              <div>
                <span class="date-info">{{
                  formatDate(other.shareCreatedAt)
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </section>

  <section class="modal-btns">
    <button class="submit-btn" *ngIf="!(isDocumentInArchive && (loggedInUser.roleId === 9 && !permissions.deleteInArchive && !permissions.deleteEverything && data.submission.archive)) && loggedInUser.roleId !== 9 && !(!data.isNotStudentPrecheck && loggedInUser.roleId === 10 && submissionUserId === loggedInUser?.id)" (click)="submit()">
      {{ 'general.submit' | translate }}
    </button>
    <button class="cancel-btn" *ngIf="!(data.isNotStudentPrecheck)" (click)="cancel()">
      {{ 'general.cancel' | translate }}
    </button>
  </section>
</section>